import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("nigi_admin_token", res.data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#F8F5F0] flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="overline text-[#B69A69] mb-3">NiGi · Admin</div>
          <h1 className="font-serif-display text-4xl text-[#292524]">Sign in</h1>
        </div>
        <div className="space-y-6">
          <div>
            <label className="overline text-[#292524]/70">Email</label>
            <input
              data-testid="admin-email"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#B69A69]/50 py-2 outline-none focus:border-[#522C36]"
            />
          </div>
          <div>
            <label className="overline text-[#292524]/70">Password</label>
            <input
              data-testid="admin-password"
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#B69A69]/50 py-2 outline-none focus:border-[#522C36]"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-[#522C36] text-[#F8F5F0] py-4 overline hover:bg-[#3d1f27] disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Enter"}
          </button>
        </div>
      </form>
    </div>
  );
}
